import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, CalendarCheckIcon, MessagesSquareIcon, ClockIcon } from 'lucide-react';
import { business, images } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
const factIcons = [MessagesSquareIcon, CalendarCheckIcon, ClockIcon];
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="w-full bg-ink pt-[76px] lg:pt-[84px]" data-id="element-188" data-mp="129h6c3bjvskt">
      <div className="mx-auto grid max-w-content items-stretch gap-0 lg:grid-cols-2" data-id="element-189" data-mp="127edlbj0jlce">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex flex-col justify-center px-5 py-12 lg:px-8 lg:py-20" data-id="element-190" data-mp="xb5s7ge82vws">
          <p className="mb-5 flex items-center gap-3 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-191" data-mp="3d1sbr0oqzpup">
            <span className="h-px w-10 bg-gold" aria-hidden="true" data-id="element-192" data-mp="3825wklpczzj9" />
            {t.hero.eyebrow}
          </p>

          <h1 className="font-display text-[2.4rem] font-bold uppercase leading-[0.95] text-cream sm:text-5xl lg:text-6xl" data-id="element-193" data-mp="3j9u1d0dmvqmc">
            {t.hero.titleTop}
            <span className="block text-gold" data-id="element-194" data-mp="39acx8ne15ksh">{t.hero.titleAccent}</span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-cream/80 lg:text-lg" data-id="element-195" data-mp="39cpain8uf6z7">
            {t.hero.subtitleLead}{' '}
            <strong className="font-semibold text-cream" data-id="element-196" data-mp="30hhsdush5r38">{t.hero.subtitleStrong}</strong>
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-197" data-mp="358zpu8vah9jg">
            <a href="#agendar" className="flex items-center justify-center gap-2 rounded-sm bg-gold px-7 py-4 font-display text-base font-semibold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-198" data-mp="2qk3mgp46gkp6">
              <CalendarCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-199" data-mp="2lkqz839e9bm2" />
              {t.hero.ctaBook}
            </a>
            <a href={business.phoneHref} className="flex items-center justify-center gap-2 rounded-sm border border-cream/35 px-7 py-4 font-display text-base font-semibold uppercase tracking-wider text-cream transition-colors duration-150 ease-out hover:border-gold hover:text-gold-light" data-id="element-200" data-mp="s2jnhxye22k1">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-201" data-mp="degdmdh866py" />
              {t.hero.ctaCall}
            </a>
          </div>
        </motion.div>

        <div className="relative min-h-[320px] lg:min-h-[620px]" data-id="element-202" data-mp="161t1cqz4gkku">
          <img src={images.banner} alt={t.hero.imageAlt} className="h-full w-full bg-black object-cover object-center" data-id="element-203" data-mp="162m0b5rua5sf" />
        </div>
      </div>

      <div className="w-full border-y border-gold/25 bg-panel" data-id="element-204" data-mp="x0l3ub4fjnrt">
        <ul className="mx-auto flex max-w-content flex-col divide-y divide-white/5 px-5 text-sm text-cream/75 sm:flex-row sm:divide-x sm:divide-y-0 sm:divide-white/10 lg:px-8" data-id="element-205" data-mp="3lt774vhctzwd">
          {t.hero.facts.map((label, index) => {
          const Icon = factIcons[index];
          return <li key={label} className="flex items-center gap-3 py-3.5 sm:flex-1 sm:justify-center" data-id="element-206" data-mp="21aekbl6vatcq" data-mpi={index}>
                <Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-207" data-mp="269hgsh8s7r93" />
                <span data-id="element-208" data-mp="2b0fwbely4lba">{label}</span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}